import { useMemo, useState } from 'react';
import '../App.css';
import FaultLevelLightIcon from './FaultLevelLightIcon';
import TablePaginationComponent from './TablePaginationComponent';
import PropTypes from 'prop-types';

const LrvStatusTable = (props) => {
    const { isLoading, carFaults, rowsPerPage } = props;

    const [page, setPage] = useState(1);

    const handleChange = (event, value) => {
        setPage(value);
    };

    useMemo(() => {
        if (isLoading) {
            setPage(1);
        }
    }, [isLoading]);

    const columns = [
        { id: 'carCode', label: 'Car No.', width: '50px', align: 'center' },
        { id: 'routeCode', label: 'Route', width: '50px', align: 'center' },
        { id: 'stationNameTc', label: 'Current Station', align: 'center' },
        { id: 'speed', label: 'Speed', width: '40px', align: 'center' },
        { id: 'runCode', label: 'Run No.', width: '30px', align: 'center' },
        { id: 'vvvfFaultLevel', label: 'Traction', width: '73px', align: 'center', format: (value) => { return (<FaultLevelLightIcon level={value} />); } },
        { id: 'sivFaultLevel', label: 'Auxiliary', width: '73px', align: 'center', format: (value) => { return (<FaultLevelLightIcon level={value} />); } },
        { id: 'brakeFaultLevel', label: 'Brake', width: '73px', align: 'center', format: (value) => { return (<FaultLevelLightIcon level={value} />); } },
        { id: 'doorFaultLevel', label: 'Door', width: '73px', align: 'center', format: (value) => { return (<FaultLevelLightIcon level={value} />); } },
        { id: 'vacFaultLevel', label: 'A/C', width: '73px', align: 'center', format: (value) => { return (<FaultLevelLightIcon level={value} />); } },
    ];

    return (
        <TablePaginationComponent
            isLoading={isLoading}
            columns={columns}
            rows={carFaults}
            rowsPerPage={rowsPerPage}
            page={page}
            onChange={handleChange}
        />
    );
};

LrvStatusTable.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    carFaults: PropTypes.array.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default LrvStatusTable;